import { useSelector, useDispatch } from 'react-redux';
const useTypedSelector = useSelector;
const useTypedDispatch = useDispatch;
export { useTypedDispatch as useDispatch, useTypedSelector as useSelector };
//# sourceMappingURL=types.js.map